import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number5Circle"
const Number5CircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.125 7V8.8H11.225L11.06 10.45C11.27 10.405 11.585 10.375 11.87 10.375 12.68 10.375 13.58 10.57 14.315 11.17 15.14 11.83 15.65 12.895 15.65 14.02 15.65 16.09 13.895 17.65 11.78 17.65 10.565 17.65 9.515 17.215 8.6 16.3L9.98 15.01C10.43 15.49 11.075 15.85 11.78 15.85 12.245 15.85 12.695 15.685 13.04 15.37 13.4 15.04 13.625 14.56 13.625 14.02 13.625 13.45 13.385 12.94 12.98 12.595 12.65 12.31 12.2 12.175 11.705 12.175 11.195 12.175 10.61 12.37 10.16 12.745L8.9 12.565 9.575 7z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default Number5CircleIcon
